import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.uploadDetails}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On data check get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}
function* postRequest(action) {
    const { dataCheck } = action.payload;
    const url = config.api.paths.uploads;
    try {
        const { data } = yield call(http.authorized.post, url, dataCheck);
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On data check post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.DATA_CHECK_GET_REQUEST, getRequest),
        takeLatest(actionTypes.DATA_CHECK_POST_REQUEST, postRequest)
    ]);
}
